import { render } from "./operationPanelSetting.vue?vue&type=template&id=2fff9565&scoped=true"
import script from "./operationPanelSetting.vue?vue&type=script&lang=js"
export * from "./operationPanelSetting.vue?vue&type=script&lang=js"

import "./operationPanelSetting.vue?vue&type=style&index=0&id=2fff9565&scoped=true&lang=less"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fff9565"]])

export default __exports__